import React, { Component } from 'react';
import { Provider } from 'react-redux';

// Components
import store from './Store/store';
import Content from './Layouts/content'
// Styling
import './static/css/styles.css'
import './static/css/components.css'

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        
          <Content />
        
      </Provider>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js